export default __webpack_public_path__ + "static/media/bbnaija.ca81aaef.png";